class servicesService {
    constructor(formState) {
        this.formState = formState;
    }
    sendLead(formData) {
        fetch('/api/ev-lead-landing', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        }).then(response => response.json())
            .then(response => {
            var _a, _b, _c;
            if (response['id_registro']) {
                const formName = this.formState.manageState('formName');
                const form = document.querySelector(formName);
                (_a = form.querySelector('.load-send-form')) === null || _a === void 0 ? void 0 : _a.classList.remove("d-flex");
                (_b = form.querySelector('.js-confirmation-mess')) === null || _b === void 0 ? void 0 : _b.classList.add('d-flex');
                form.querySelector('.btn-form').disabled = false;
                form.getElementsByClassName('value-service')[0].classList.remove("d-none");
                (_c = form.querySelector('#sending-mss-service')) === null || _c === void 0 ? void 0 : _c.classList.add("d-none");
            }
        });
    }
}
export { servicesService };
